import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import Stack from '@mui/material/Stack';

import PayerPlanListItem from './PayerPlanListItem';
import PayerPlanEditorButton from './PayerPlanEditorButton';
import BlankContent from '../common/BlankContent';

const ListPayerPlansScreen = ({patientId, payerPlans = []}) => {
  return (
    <Box>
      <Stack padding={1}>
        <Stack direction='row' spacing={1} justifyContent='flex-end' paddingBottom={2}>
          <PayerPlanEditorButton 
            patientId={patientId}
            editing={false}
            variant='contained'
            buttonText='Add Insurance Plan'
          />
        </Stack>
        <Grid container spacing={1}>
          {
            payerPlans.map(p => 
              <Grid key={p.id} item xs={12} md={6}>
                <PayerPlanListItem key={p.id} payerPlan={p} />
              </Grid>
            )
          }
          {
            payerPlans.length === 0 &&
            <Stack direction='row' justifyContent='center' width='100%' paddingTop={3}>
              <BlankContent 
                Icon={MedicalInformationIcon}
                body='No insurance plans added yet.'
              />
            </Stack>
          }
        </Grid>
      </Stack>
    </Box>
  );
};

export default ListPayerPlansScreen;